// extracted by mini-css-extract-plugin
export var growableInput = "_8o-0";
export var tagContainer = "_8o-2";
export var textInput = "_8o-1";